export const splitEmailRecipients = (value = '') => (
    String(value || '')
        .split(/[;,]/)
        .map((email) => email.trim())
        .filter(Boolean)
)

export const normalizeEmailRecipients = (value = '') => splitEmailRecipients(value).join(',')

export const isValidEmailRecipient = (value = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())

export const validateEmailRecipients = (value = '', required = false) => {
    const recipients = splitEmailRecipients(value)

    if (recipients.length === 0)
        return !required

    return recipients.every(isValidEmailRecipient)
}
